import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { ServiceFactory } from '../../../../../../services/ServiceFactory';
import { ChangeAscriptionFormData } from '../../../../../../services/invoice/InvoiceService';

interface Props {
  invoiceNumber: string;
}

export default function useGetChangeAscriptionDataQuery({
  invoiceNumber,
}: Props): UseQueryResult<ChangeAscriptionFormData> {
  return useQuery({
    queryKey: ['getChangeAscriptionData', invoiceNumber],
    queryFn: () => ServiceFactory.createInvoiceService().getAscriptionFormData(invoiceNumber),
  });
}
